import React from 'react';
import { IconSvgProps } from '@models/common';

const SearchSparkle: React.FC<IconSvgProps> = (props) => {
  const { size = 20, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'>
      <path
        d='M9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333C12.2731 15.8333 14.8832 13.7087 15.6233 10.8333'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.5 17.5L13.875 13.875'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.8751 1.94838C13.028 1.53543 13.612 1.53543 13.7649 1.94838L14.6107 4.23447C14.6344 4.29861 14.6718 4.35686 14.7202 4.40522C14.7686 4.45358 14.8268 4.4909 14.891 4.51462L17.1771 5.36043C17.5899 5.51331 17.5899 6.09732 17.1771 6.2502L14.891 7.09602C14.8268 7.11976 14.7685 7.1571 14.7201 7.20549C14.6718 7.25387 14.6344 7.31215 14.6107 7.37633L13.7649 9.66241C13.612 10.0752 13.028 10.0752 12.8751 9.66241L12.0293 7.37633C12.0056 7.31215 11.9682 7.25387 11.9198 7.20549C11.8714 7.1571 11.8132 7.11976 11.749 7.09602L9.46291 6.2502C9.05012 6.09732 9.05012 5.51331 9.46291 5.36043L11.749 4.51462C11.8132 4.49088 11.8714 4.45354 11.9198 4.40515C11.9682 4.35677 12.0056 4.29849 12.0293 4.23431L12.8751 1.94838Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default SearchSparkle;
